module.exports = __webpack_public_path__ + "img/bim8.745f5fee.png";